module.exports = __webpack_public_path__ + "4208e8d8.svg";